(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[257],{

/***/ 2622:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/account/[[...route]]",
      function () {
        return __webpack_require__(48);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 48:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ Account; }
});

// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(4246);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(7378);
// EXTERNAL MODULE: ../node_modules/next/router.js
var next_router = __webpack_require__(6677);
// EXTERNAL MODULE: ../node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(9312);
;// CONCATENATED MODULE: ../node_modules/lower-case/dist.es2015/index.js
/**
 * Source: ftp://ftp.unicode.org/Public/UCD/latest/ucd/SpecialCasing.txt
 */
var SUPPORTED_LOCALE = {
    tr: {
        regexp: /\u0130|\u0049|\u0049\u0307/g,
        map: {
            İ: "\u0069",
            I: "\u0131",
            İ: "\u0069",
        },
    },
    az: {
        regexp: /\u0130/g,
        map: {
            İ: "\u0069",
            I: "\u0131",
            İ: "\u0069",
        },
    },
    lt: {
        regexp: /\u0049|\u004A|\u012E|\u00CC|\u00CD|\u0128/g,
        map: {
            I: "\u0069\u0307",
            J: "\u006A\u0307",
            Į: "\u012F\u0307",
            Ì: "\u0069\u0307\u0300",
            Í: "\u0069\u0307\u0301",
            Ĩ: "\u0069\u0307\u0303",
        },
    },
};
/**
 * Localized lower case.
 */
function localeLowerCase(str, locale) {
    var lang = SUPPORTED_LOCALE[locale.toLowerCase()];
    if (lang)
        return lowerCase(str.replace(lang.regexp, function (m) { return lang.map[m]; }));
    return lowerCase(str);
}
/**
 * Lower case as a function.
 */
function lowerCase(str) {
    return str.toLowerCase();
}
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../node_modules/no-case/dist.es2015/index.js

// Support camel case ("camelCase" -> "camel Case" and "CAMELCase" -> "CAMEL Case").
var DEFAULT_SPLIT_REGEXP = [/([a-z0-9])([A-Z])/g, /([A-Z])([A-Z][a-z])/g];
// Remove all non-word characters.
var DEFAULT_STRIP_REGEXP = /[^A-Z0-9]+/gi;
/**
 * Normalize the string into something other libraries can manipulate easier.
 */
function noCase(input, options) {
    if (options === void 0) { options = {}; }
    var _a = options.splitRegexp, splitRegexp = _a === void 0 ? DEFAULT_SPLIT_REGEXP : _a, _b = options.stripRegexp, stripRegexp = _b === void 0 ? DEFAULT_STRIP_REGEXP : _b, _c = options.transform, transform = _c === void 0 ? lowerCase : _c, _d = options.delimiter, delimiter = _d === void 0 ? " " : _d;
    var result = replace(replace(input, splitRegexp, "$1\0$2"), stripRegexp, "\0");
    var start = 0;
    var end = result.length;
    // Trim the delimiter from around the output string.
    while (result.charAt(start) === "\0")
        start++;
    while (result.charAt(end - 1) === "\0")
        end--;
    // Transform each token independently.
    return result.slice(start, end).split("\0").map(transform).join(delimiter);
}
/**
 * Replace `re` in the input string with the replacement value.
 */
function replace(input, re, value) {
    if (re instanceof RegExp)
        return input.replace(re, value);
    return re.reduce(function (input, re) { return input.replace(re, value); }, input);
}
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../node_modules/dot-case/dist.es2015/index.js


function dotCase(input, options) {
    if (options === void 0) { options = {}; }
    return noCase(input, (0,tslib_es6.__assign)({ delimiter: "." }, options));
}
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../node_modules/param-case/dist.es2015/index.js


function paramCase(input, options) {
    if (options === void 0) { options = {}; }
    return dotCase(input, (0,tslib_es6.__assign)({ delimiter: "-" }, options));
}
//# sourceMappingURL=index.js.map
// EXTERNAL MODULE: ../node_modules/@backpackjs/storefront/dist/index.js
var dist = __webpack_require__(2031);
// EXTERNAL MODULE: ./src/templates/account/index.js
var account = __webpack_require__(9075);
// EXTERNAL MODULE: ./src/_components/index.js + 9 modules
var _components = __webpack_require__(2310);
;// CONCATENATED MODULE: ./src/pages/account/[[...route]].jsx

/* eslint-disable import/no-unresolved */ 





var isBrowser = "object" !== "undefined";
var __N_SSG = true;
function Account(param) {
    var initialSettings = param.settings;
    var ref6, ref1;
    var liveSettings = (0,dist.useSettings)();
    var settings = liveSettings || initialSettings;
    var router = (0,next_router.useRouter)();
    var ref2 = (0,react.useState)(null), AccountSubTemplate = ref2[0], setAccountSubTemplate = ref2[1];
    var ref3 = (0,react.useState)(true), first = ref3[0], setFirst = ref3[1];
    // If account.menu has been set, we use the first item in the list as default subRoute
    var defaultAccountTemplateComp = "orders";
    var ref4 = (0,dist.useCustomerAuth)({
        autoRedirect: true,
        defaultRoute: "/account/orders",
        id: "withAccount"
    }), customer = ref4.customer, authenticated = ref4.authenticated;
    /*
      Map an template/account/*.jsx component to an /account/subRoute
      Doing this in a useEffect is important so that these chunked out templates get dynamically loaded
    */ (0,react.useEffect)(function() {
        var ref, ref5;
        if (authenticated === undefined) return;
        var TemplateComponent = null;
        var TemplateComponentName;
        if (typeof account/* default */.Z !== "object" || !Object.keys(account/* default */.Z).length) {
            return;
        }
        var subRoute = router === null || router === void 0 ? void 0 : (ref = router.query) === null || ref === void 0 ? void 0 : (ref5 = ref.route) === null || ref5 === void 0 ? void 0 : ref5[0];
        if (subRoute) {
            TemplateComponentName = paramCase(subRoute);
            var haveTemplateForSubRoute = account/* default */.Z[TemplateComponentName];
            if (haveTemplateForSubRoute) {
                // If we have an account template matching this subRoute we use the template;
                TemplateComponent = account/* default */.Z[TemplateComponentName];
            } else {
                // The subRoute is not defined in the menu and there's no template for it. Display the default account template
                TemplateComponent = account/* default */.Z[defaultAccountTemplateComp];
            }
        } else if (account/* default */.Z[defaultAccountTemplateComp]) {
            // path is /accounts e.g no subRoute
            // We render the first menu item as default
            TemplateComponent = account/* default */.Z[defaultAccountTemplateComp];
        }
        var activeAccountTemplate = TemplateComponent ? /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Suspense, {
            fallback: "Loading...",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TemplateComponent, {
                settings: settings,
                customer: customer
            })
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
            children: [
                "`$",
                TemplateComponentName,
                " account template not defined`"
            ]
        });
        setAccountSubTemplate(activeAccountTemplate);
    }, [
        router === null || router === void 0 ? void 0 : (ref6 = router.query) === null || ref6 === void 0 ? void 0 : (ref1 = ref6.route) === null || ref1 === void 0 ? void 0 : ref1[0],
        authenticated,
        account/* default */.Z,
        customer
    ]);
    (0,react.useEffect)(function() {
        setFirst(false);
    }, []);
    if (!isBrowser) return null;
    if (first) {
        return null;
    }
    // render the correct account template based on the account/path
    return  true && customer && AccountSubTemplate ? AccountSubTemplate : /*#__PURE__*/ (0,jsx_runtime.jsx)(_components/* AccountsAuthLoader */.iT, {});
};


/***/ }),

/***/ 9075:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({
    // logged out
    activate: null,
    login: null,
    register: null,
    "reset-password": null,
    // logged in
    "address-book": null,
    "edit-profile": null,
    order: null,
    orders: null
});


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [774,888,179], function() { return __webpack_exec__(2622); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);